export default __webpack_public_path__ + "249c73be8228189cdccf9937b3ab6e57.svg";